import { Stack, Typography } from "@mui/material";
import { Box } from "@mui/material";
import { EmployeeAccount, Transaction } from "../../../models";
import { SideDrawer } from "../../shared/SideDrawer";
import { formatCurrency } from "../../../utils/formatters";

export const RewardsSentTableDrawer = ({ open, setIsOpen, rewardPayment, rewardSendingAccount } : 
    {   
        open: boolean,
        setIsOpen: (isOpen: boolean) => void,
        rewardPayment: Transaction | null,
        rewardSendingAccount: EmployeeAccount | null 
    }) => {
        return (
            <SideDrawer
                title="Reward Sent"
                open={open}
                setIsOpen={setIsOpen}
            >
                <Stack spacing={3} mx={2}>
                    <Box>
                        <Typography variant="subtitle2" color="black" fontWeight="bold">
                            Sending Account
                        </Typography>
                        <Typography variant="body1">
                            {rewardSendingAccount?.name}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" color="black" fontWeight="bold">
                            Amount
                        </Typography>
                        <Typography variant="body1">
                            {formatCurrency(rewardPayment?.transactionAmount.amount ?? 0)}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" color="black" fontWeight="bold">
                            Sender
                        </Typography>
                        <Typography variant="body1">
                            {rewardPayment?.paymentInfo?.sender.firstName} {rewardPayment?.paymentInfo?.sender.lastName}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" color="black" fontWeight="bold">
                            Receiver
                        </Typography>
                        <Typography variant="body1">
                            {rewardPayment?.paymentInfo?.receiver.firstName} {rewardPayment?.paymentInfo?.receiver.lastName}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" color="black" fontWeight="bold">
                            Category
                        </Typography>
                        <Typography variant="body1">
                            {rewardPayment?.paymentInfo?.reasonCategory}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="subtitle2" color="black" fontWeight="bold">
                            Message
                        </Typography>
                        <Typography variant="body1">
                            {rewardPayment?.paymentInfo?.reason}
                        </Typography>
                    </Box>
                </Stack>
            </SideDrawer>
        )
}